exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-number{display:flex;flex-flow:row wrap;padding-bottom:5px}.labeled-number .data-label{color:#aaa;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/labeled-number/index.scss
// module id = 5265
// module chunks = 0